import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { USER_MODE_EVENTS } from '@/core/values/core.values';
import { Status } from '@/models/status.model';
import { _APP_STORE } from '@/core/values/app.values';
import { AUTH_STORE } from '@/auth/store/auth.store';
import { ScreenMirroringService } from '@/services/screen.mirroring.service';
import { SCREEN_MIRRORING_EVENTS } from '@/values/screen.mirroring.values';
import { COURSES_EVENTS } from '@/courses/values/courses-events.values';
import { _HOMEWORKS_STORE } from '@/homework/values/homeworks.values';
import { CHANGE_PRESENTATION_TASK_USER_EVENT } from '@/content/values/ed-presentation-mode.values';

@Component({
  name: 'ed-user-mode'
})
export default class EdUserModeComponent extends Vue {

  public readonly onChange: string = 'onChange';
  public status: Status = new Status();

  public options = [{
    key: 'normal',
    label: 'screenMirroring.normalLabel',
    icon: 'study-book',
    selected: false
  },{
    key: 'paper',
    label: 'screenMirroring.paperLabel',
    icon: 'pencil-paper',
    selected: false
  },{
    key: 'book',
    label: 'screenMirroring.bookLabel',
    icon: 'book-solid',
    selected: false
  }];

  /* Computed */
  get value() {
    return this.$store.state.AppStore.userMode;
  }

  get optionList() {
    return this.options.map(o => {
      return {
        ...o,
        selected: this.value === o.key
      }
    });
  }

  get userId() {
    return this.$store.state.AuthStore.user.userId;
  }

  get presentationSocketConnected(): boolean {
    return this.$store.state.AppStore.presentationSocketConnected;
  }

  get isPresentationModeEnabled() {
    return this.$store.state.CourseStore.isPresentationStudentMode || this.$store.state.CourseStore.isPresentationTeacherMode;
  }

  /* Methods */
  setOption(option) {
    ScreenMirroringService.screenModeSelection(this, option.key);
  }

  setStatus() {
    if(!this.presentationSocketConnected || !this.userId || !this.value) {
      this.status.setLoading();
      this.$store.subscribe((mutation) => {
        if(mutation.type === _APP_STORE.MUTATIONS.SET_PRESENTATION_SOCKET_CONNECTED || 
          // mutation.type === AUTH_STORE.MUTATIONS.SET_USER_INFO ||
          mutation.type === _APP_STORE.MUTATIONS.SET_USER_MODE) {
          this.validateStatus();    
        }
      });
    } else {
      setTimeout(() => { this.status.setLoad(); }, 500); 
    }
  }

  validateStatus() {
    if(this.presentationSocketConnected && this.userId && this.value) {
      this.status.setLoad();
    }
  }

  refreshCourse({courseId, sectionId}:{courseId:number, sectionId:number}) {
    if( this.isPresentationModeEnabled ) {
      this.$edEventBus.$emit(CHANGE_PRESENTATION_TASK_USER_EVENT);
    } else {
      this.$edEventBus.$emit(COURSES_EVENTS.REFRESH_WIDGET_COURSE, {courseId});
      this.$store.commit(_HOMEWORKS_STORE.MUTATIONS.REMOVE_STUDENT_HOMEWORK, {courseId: courseId, sectionId: sectionId});
    }
  }

  /* Hooks */
  created() {
    this.setStatus();
  }

  mounted() {
    this.$edEventBus.$on( SCREEN_MIRRORING_EVENTS.ON_REFRESH_COURSE, this.refreshCourse);
  }

  beforeDestroy() {
    this.$edEventBus.$off( SCREEN_MIRRORING_EVENTS.ON_REFRESH_COURSE, this.refreshCourse);
  }

}